import styled from "styled-components";

const StyledParagraph = styled.p`
  font-size: 0.9rem;
  line-height: 1.8rem;
  color: white;
`;

export default StyledParagraph;
